import React from 'react';
import { Box, Typography } from '@mui/material';
import DateRangePicker from '../../../../reusable-components/date-range-picker/DateRangePicker';
import { DATE_FORMAT_SLASH } from '../../../../../utils/formatTime';
import './filterField.scss';

interface CreatedDateFilterFieldProps {
  value: { startDate: Date | null; endDate: Date | null };
  onChange: (startDate: Date | null, endDate: Date | null) => void;
}

const CreatedDateFilterField: React.FC<CreatedDateFilterFieldProps> = ({ value, onChange }) => {
  return (
    <Box className="filterField">
      <Typography className="filterFieldLabel">Created date</Typography>
      <Box className="filterFieldInput">
        <DateRangePicker
          value={value}
          onChange={onChange}
          placeholder="Start date - End date"
          label="Created Date Range"
          format={DATE_FORMAT_SLASH}
        />
      </Box>
    </Box>
  );
};

export default CreatedDateFilterField;
